<template>
<div id="cyclic-definition_create">
  <v-form ref="form" lazy-validation>
    <v-text-field v-model="form.name" :label="`${$t('cyclic.name')}`" :rules="nameRules" required></v-text-field>

    <v-textarea v-model="form.formule" :label="`${$t('stats.formule')}`" :rules="formuleRules" required></v-textarea>

    <v-select v-model="form.type" item-text="name" item-value="type" :items="types" :label="`${$t('stats.type')}`"> </v-select>
    <v-select v-model="form.schemaId" :label="`${$t('stats.schema')}`" item-text="name" item-value="id" :items="schemas" required></v-select>


    <v-btn color="primary" @click="submit">
      {{ $t('cyclic.continue') }}
    </v-btn>
  </v-form>
</div>
</template>

<script>
import http from '@/plugins/http'


export default {
  props: ['schemas'],
  data() {
    return {
      nameRules: [
        v => !!v || this.$t('stats.name_required')
      ],
      formuleRules: [
        v => !!v || this.$t('stats.formule_required'),
      ],
      statusRules: [v => !!v || "Status is required"],
      loading: false,
      form: {}
    }
  },
  computed: {
    types() {
      return [{
          "type": "line",
          "name": this.$t('stats.charts.line')
        }, {
          "type": "bar",
          "name": this.$t('stats.charts.bar')
        },
        {
          "type": "stackedbar",
          "name": this.$t('stats.charts.bar100')
        }, {
          "type": "column",
          "name": this.$t('stats.charts.column')
        }
      ]
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        let postData = {

          "name": this.form.name,
          "formule": this.form.formule,
          "type": this.form.type,
          "schemaId": this.form.schemaId
        }
        http.post('statistics/create', postData)
          .then(() => {
            this.$store.commit("setSnack", {
              message: this.$t('stats.messages.create_success'),
              color: "success"
            })
            this.$router.push({
              "path": "/form/" + this.form.schemaId
            })
          }).catch(() => {
            this.$store.commit("setSnack", {
              message: this.$t('stats.messages.create_error'),
              color: "danger"
            })
          })
      } else {
        this.form.name = "aaaaaa"
      }
    }
  }
}
</script>

<style>

</style>
